<template>
  <form @submit.prevent="handleSubmit">
    <fieldset class="card">
      <h3 class="icon-heading tiny">
        <span class="icon"><svg width="28px" height="28px" viewBox="0 0 28 28"><use xlink:href="/static/sprites.svg#glyph-medium-object-sold"></use></svg></span>
        <span class="icon-heading-title">
          <span class="title">Utlevering</span>
        </span>
      </h3>

      <div class="grid-x grid-padding-x">
        <div class="cell medium-12">
          <label for="Lev_dato">Utlevert dato *</label>
          <div class="input-container date" :class="{'form-error': errors.has('Lev_dato')}">
            <b-datepicker
              :show-week-number="false"
              :editable="false"
              :first-day-of-week="1"
              v-model="form.Lev_dato"
              name="Lev_dato"
              placeholder="Vis kalender..."
              icon="calendar-today"
              ref="Lev_dato"
              id="Lev_dato"
              v-validate="'required'"
              :disabled="!isPresenceOwner">
              <button class="button disabled" v-if="!form.Lev_dato" @click.prevent="$refs.Lev_dato.toggle()"><span>Slett dato</span></button>
              <button class="button" v-else @click.prevent="form.Lev_dato = null"><span>Slett dato</span></button>
            </b-datepicker>
            <span class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-date"></use></svg></span>
            <span class="form-error-label" v-if="errors.has('Lev_dato')">
              <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
              {{errors.first('Lev_dato')}}
            </span>
          </div>
        </div>
      </div>

      <div class="grid-x grid-padding-x">
        <div class="cell">
          <label for="Legtype">Legitimasjonstype <span v-show="form.Legitimert">*</span></label>
          <div class="select-container" :class="{ 'form-error': errors.has('Legtype') }">
            <select :disabled="!isPresenceOwner" id="Legtype" name="Legtype" v-model="form.Legtype" @change="$validator.validate('Legitimert'); form.Legitimert = false;">
              <option v-for="option in legDropdown" v-bind:value="option.key" v-bind:key="option.key">{{option.val}}</option>
            </select>
            <span class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-select"></use></svg></span>
            <span class="form-error-label" v-if="errors.has('Legtype')">
              <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
              {{errors.first('Legtype')}}
            </span>
          </div>
        </div>
      </div>

      <div class="gird-x grid-padding-x">
        <div class="cell">
          <label>Legitimert <span v-if="form.Legtype">*</span></label>
          <div class="radio-button-container" :class="{ 'form-error': errors.has('Legitimert') }">
            <ul>
              <li><input type="radio" :disabled="!isPresenceOwner || !form.Legtype" v-model="form.Legitimert" v-bind:value="false" name="Legitimert" id="ikke-legitimert" v-validate="{ included: form.Legtype ? ['true', true] : [] }"> <label for="ikke-legitimert">Nei</label></li>
              <li><input type="radio" :disabled="!isPresenceOwner || !form.Legtype" v-model="form.Legitimert" v-bind:value="true" name="Legitimert" id="legitimert" checked> <label for="legitimert">Ja</label></li>
            </ul>
          </div>
          <div class="cell small-12 large-12 medium-12">
            <div class="input-container" :class="{ 'form-error': errors.has('Legitimert') }">
              <span class="form-error-label" v-if="errors.has('Legitimert')" style="left:0; right:0;width:67%;bottom:-2.5rem;">
                <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
                Vennligst bekreft legitimasjonen
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="grid-x grid-padding-x">
        <div class="cell auto"></div>
        <div class="cell shrink">
          <a href="javascript:;" v-if="isPresenceOwner && $store.getters.isFormSubmittable" @click="handleSubmit()" class="button primary initiate-loading"><span class="button-title">Lagre</span></a>
          <a href="javascript:;" v-if="!isPresenceOwner && $store.getters.isFormProcessing" class="button primary loading"><span class="button-title">Lagrer</span> <span class="loader-spinner"></span></a>
          <a href="javascript:;" v-if="!isPresenceOwner || $store.getters.isFormLoading" class="button primary disabled"><span class="button-title">Lagre</span></a>
        </div>
      </div>
    </fieldset>
  </form>
</template>

<script>
import InstillingerService from '@/services/InstillingerService'
import KundeService from '@/services/KundeService'
import moment from 'moment'
import bus from '@/plugins/event-bus'

export default {
  name: 'KundeKontraktObjektTabKjoperUtlevering',
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    kunde: {
      type: Object,
      required: true
    },
    objekt: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      form: {},
      legDropdown: [],
      presenceChannelName: null
    }
  },
  computed: {
    isPresenceOwner: function () {
      return this.$store.getters['presence/isOwner'](this.presenceChannelName)
    }
  },
  created () {
    // Set name for the WS channel
    this.presenceChannelName = 'presence-objekt-edit-' + this.objekt.Objektid

    this.setupForm()
  },
  methods: {
    setupForm: function () {
      this.form = {
        Legtype: this.objekt.Legtype,
        Legitimert: this.objekt.Legitimert,
        Lagerleieinfo: this.objekt.Lagerleieinfo,
        Lev_dato: this.objekt.Lev_dato
      }

      if (this.form.Lev_dato) {
        this.form.Lev_dato = new Date(Date.parse(this.form.Lev_dato))
      }

      // And load the legitimasjon settings
      this.legDropdown = []
      this.legDropdown.unshift({key: this.form.Legtype, val: 'Laster...'})

      InstillingerService('legitimasjon').dropdown()
        .then((response) => {
          this.legDropdown = response.data
          this.legDropdown.unshift({key: 0, val: 'Velg legitimasjonstype'})
        })
        .catch(() => {
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste ned innstillinger')
        })
        .then(() => {
          this.setFormLoading(false)
        })
    },
    handleSubmit: function () {
      if (!this.isPresenceOwner || !this.isFormSubmittable()) {
        return
      }

      this.setFormProcessing(true)

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.setFormProcessing(false)
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
          } else {
            let data = this._.clone(this.form)

            if (data.Lev_dato) {
              const df = new Date(Date.parse(data.Lev_dato))
              data.Lev_dato = moment(df).format('YYYY-MM-DD')

              data.Lokasjon = '<utlevert>'
              data.Lokasjonid = 159
            }

            KundeService.saveKundeKontraktObjekt(this.kunde.Kundenr, this.objekt.Kontraktnr, this.objekt.Objektid, data)
              .then((response) => {
                // Show success alert
                this.$helpers.showSuccessAlert('Objekt er lagret')

                // Emit event so we can update list
                bus.$emit('kunde-kontrakt-objekt-updated', response.data)
              })
              .catch((error) => {
                // Put API errors into the error container
                this.$helpers.sendApiErrorsToValidator(error, this.errors)

                // Check if new errors appeared
                if (this.errors.any()) {
                  this.$validator.resume()
                  this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
                } else {
                  this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst prøv igjen', 2500)
                }
              })
              .then(() => {
                this.setFormProcessing(false)
              })
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeKontraktObjektTabKjoperUtlevering.vue